import type { ILoadTaskOptions } from 'task-loader/lib/interface/ILoadTaskOptions';
import AbstractLoadTask from 'task-loader/lib/task/AbstractLoadTask';
import type FontFaceObserver from 'fontfaceobserver';
import { loadFont } from '../loader.utils';

export default class LoadFontMethodTask extends AbstractLoadTask<unknown> {
  declare protected options: LoadFontMethodTaskOptions;

  public constructor(options: LoadFontMethodTaskOptions) {
    super(Object.assign(options, { batchSize: 1, cached: false }));
  }

  public loadAsset(name: string, update: (progress: number) => void): Promise<void> {
    return loadFont(name, this.options.variant, update);
  }

  public dispose(): void {
    super.dispose();
  }
}

export interface LoadFontMethodTaskOptions extends ILoadTaskOptions<unknown> {
  variant?: FontFaceObserver.FontVariant;
}
